/**
 * SortGroupsModal — group sort options (mobile sortGroupsSheet parity).
 */
import { useState } from 'react';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { GroupSortOption } from '@wlb/shared/types/groups';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import './groups.css';

const OPTIONS: { value: GroupSortOption; titleKey: string; descKey: string }[] = [
  { value: 'newest', titleKey: 'groupDetails.options.sortNewestGroups', descKey: 'groupDetails.options.sortNewestGroupsDesc' },
  { value: 'oldest', titleKey: 'groupDetails.options.sortOldestGroups', descKey: 'groupDetails.options.sortOldestGroupsDesc' },
  { value: 'members', titleKey: 'groupDetails.options.sortMostMembers', descKey: 'groupDetails.options.sortMostMembersDesc' },
  { value: 'alpha_asc', titleKey: 'groupDetails.options.sortGroupNameAZ', descKey: 'groupDetails.options.sortGroupNameAZDesc' },
  { value: 'alpha_desc', titleKey: 'groupDetails.options.sortGroupNameZA', descKey: 'groupDetails.options.sortGroupNameZADesc' },
];

interface SortGroupsModalProps {
  selected: GroupSortOption;
  onClose: () => void;
  onApply: (option: GroupSortOption) => void;
}

export function SortGroupsModal({ selected, onClose, onApply }: SortGroupsModalProps) {
  const { t } = useTranslation();
  const [choice, setChoice] = useState<GroupSortOption>(selected);

  return (
    <Modal
      title={t('groupDetails.options.sortGroupsTitle')}
      onClose={onClose}
      labelledBy="sort-groups-modal-title"
    >
      <div className="sort-groups" role="radiogroup" aria-labelledby="sort-groups-modal-title">
        {OPTIONS.map(option => {
          const isActive = choice === option.value;
          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={isActive}
              className={`sort-groups__option${isActive ? ' sort-groups__option--active' : ''}`}
              onClick={() => setChoice(option.value)}
            >
              <span>
                <span className="sort-groups__option-title">{t(option.titleKey)}</span>
                <span className="sort-groups__option-desc">{t(option.descKey)}</span>
              </span>
              {isActive && <span className="sort-groups__check" aria-hidden>✓</span>}
            </button>
          );
        })}
        <div className="sort-groups__actions">
          <Button fullWidth onClick={() => { onApply(choice); onClose(); }}>
            {t('groupDetails.options.apply')}
          </Button>
          <Button fullWidth variant="outline" onClick={onClose}>
            {t('common.buttons.cancel')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
